import * as firebaseAuth from "firebase/auth";
import { getExistingStore } from "store";

import ServiceClientRegistry from "services/utils/ServiceClientRegistry";

export default function populateCypressGlobals() {
  if (window.Cypress) {
    window.__store__ = getExistingStore();
    window.__clientRegistry__ = ServiceClientRegistry.getInstance();
    window.__firebaseAuth__ = firebaseAuth;
    window.__firebaseAuthMocks__ = {};
  }
}
